import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ReactComponentType from '@configuratorware/configurator-frontendgui/Shared/PropTypes/ReactComponent';

import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import ErrorContainer from '@configuratorware/configurator-frontendgui/App/Shared/Containers/Error';

import ConfigurationVariantSelectionContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ConfigurationvariantSelection';
import CustomTitleEditorContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/CustomTitleEditor';
import IncompatibilityContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/Incompatibility';
import FastConfigurationContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/FastConfiguration';
import InvalidConfigurationNotice from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/InvalidConfigurationNotice';
import Option from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/Option';
import AmountPriceContainer from '@configuratorware/configurator-frontendgui/App/Shared/Containers/AmountPrice';
import { CreatorAlignTarget } from '../Visualization/CreatorAlignTarget';
import OptionDetailContainer from './Containers/Optiondetail';
import OptionsListContainer from './Containers/OptionsList';
import FullScreenView from './Components/FullScreenView/FullScreenView';

import ProductPartsListContainer from './Containers/ProductPartsList';
import DefaultLayout from './Layouts/DefaultLayout';
import Header from '../../Shared/Containers/Header';

import ResetRow from './Containers/ResetRow';

export const CustomCreatorScreen = (props) => {
  const {
    fallbackMode,
    isPortraitMode,
    showAddToCartButton,
    showConfigurationVariantSelection,
    vertical,
    fullScreenViewProps,

    configuration,

    _renderAmountPrice,
    _onToggleOptionList,
    renderConfigurationVariantSelection,
    renderCustomScreenComponents,
    renderCustomTitleEditorContainer,
    renderErrorContainer,
    renderFastConfigurationContainer,
    renderHeader,
    renderIncompatibilityDialog,
    renderLoadConfiguration,
    renderLoader,
    renderOptionDetailContainer,
    renderOptionsList,
    renderPdfDownload,
    renderSaveConfiguration,
    renderSendEmail,
    renderVisualization,
    renderLicenseNotice,
    renderInvalidConfigurationNotice,
    dispatchAction,
    onOptionClassificationSelect,
    onToggleOptionList,
    resolveConflicts,
    selectOption,
    selectOptionClassification,
    setVisible,
    viewOptionDetails,

    Layout,
  } = props;

  const [optionRef, setOptionRef] = useState(null);

  useEffect(() => {
    setVisible('optionclassificationList', true);
    setVisible('addToCartButton', configuration.showAddToCartButton);

    if (
      !configuration.showInitialOptionClassification
      && configuration.showStartHere
    ) {
      setVisible('startHere', true);
    }
  }, [
    configuration.showAddToCartButton,
    configuration.showInitialOptionClassification,
    configuration.showStartHere,
    setVisible,
  ]);

  const _renderProductParts = (
    dispatchAction,
    onOptionClassificationSelect,
    selectOptionClassification,
  ) => (
    <ProductPartsListContainer
      onSelect={(optionClassification, _optionRef) => {
        if (_optionRef) setOptionRef(_optionRef);
        onOptionClassificationSelect(
          dispatchAction,
          optionClassification,
          selectOptionClassification,
        );
      }}
    />
  );
  return (
    <Layout
      displayVerticalList={vertical}
      fallbackMode={fallbackMode}
      isPortraitMode={isPortraitMode}
      renderHeader={renderHeader}
      renderInForeground={() => renderConfigurationVariantSelection(showConfigurationVariantSelection)}
      renderLoader={renderLoader}
      // renderLoader={() =><div style={{position:"absolute", background:"green"}}>HÖÖÖE</div>}
      renderMain={() => (
        <>
          <CreatorAlignTarget />
          {renderSaveConfiguration()}
          {renderSendEmail()}
          {renderPdfDownload()}
          {renderLoadConfiguration()}

          {configuration.editCustomTitle
            ? renderCustomTitleEditorContainer()
            : null}

          {renderCustomScreenComponents()}
          {renderErrorContainer()}
          {renderFastConfigurationContainer(
            dispatchAction,
            onOptionClassificationSelect,
            selectOption,
            selectOptionClassification,
          )}
          {renderOptionsList(
            selectOption,
            dispatchAction,
            viewOptionDetails,
            _onToggleOptionList,
            onToggleOptionList,
            optionRef,
          )}
          {renderOptionDetailContainer(
            selectOption,
            dispatchAction,
            viewOptionDetails,
          )}
          {renderIncompatibilityDialog(
            viewOptionDetails,
            resolveConflicts,
            dispatchAction,
          )}
        </>
      )}
      renderProductsList={() => (
        <>
          {_renderProductParts(
            dispatchAction,
            onOptionClassificationSelect,
            selectOptionClassification,
          )}
          <ResetRow />
        </>
      )}
      renderShoppingCart={() => _renderAmountPrice(props)}
      renderVisualization={() => renderVisualization({
        fullScreenViewProps: {
          showPreviewButton: !!fullScreenViewProps.showPreviewButton,
          thumbnailDotMode: true,
          renderButtonOnTop: false,
          Component: FullScreenView,
        },
      })}
      renderLicenseNotice={renderLicenseNotice}
      renderInvalidConfigurationNotice={renderInvalidConfigurationNotice}
    />
  );
};

CustomCreatorScreen.propTypes = {
  fallbackMode: PropTypes.bool,
  isPortraitMode: PropTypes.bool,
  showAddToCartButton: PropTypes.bool,
  showConfigurationVariantSelection: PropTypes.bool,
  vertical: PropTypes.bool,

  configuration: PropTypes.object,

  _renderAmountPrice: PropTypes.func,
  _onToggleOptionList: PropTypes.func,
  renderVisualizationContainer: PropTypes.func,
  renderAmountPrice: PropTypes.func,
  renderConfigurationVariantSelection: PropTypes.func,
  renderCustomScreenComponents: PropTypes.func,
  renderCustomTitleEditorContainer: PropTypes.func,
  renderErrorContainer: PropTypes.func,
  renderFastConfigurationContainer: PropTypes.func,
  renderHeader: PropTypes.func,
  renderIncompatibilityDialog: PropTypes.func,
  renderLoadConfiguration: PropTypes.func,
  renderLoader: PropTypes.func,
  renderOptionDetailContainer: PropTypes.func,
  renderOptionsList: PropTypes.func,
  renderPdfDownload: PropTypes.func,
  renderProductParts: PropTypes.func,
  renderSaveConfiguration: PropTypes.func,
  renderSendEmail: PropTypes.func,
  renderVisualization: PropTypes.func,
  renderLicenseNotice: PropTypes.func,
  renderInvalidConfigurationNotice: PropTypes.func,
  dispatchAction: PropTypes.func,
  onOptionClassificationSelect: PropTypes.func,
  onToggleOptionList: PropTypes.func,
  resolveConflicts: PropTypes.func,
  selectOption: PropTypes.func,
  selectOptionClassification: PropTypes.func,
  setVisible: PropTypes.func,
  viewOptionDetails: PropTypes.func,
  fullScreenViewProps: PropTypes.object,

  Layout: ReactComponentType.isRequired,
};

CustomCreatorScreen.defaultProps = {
  fullScreenViewProps: { showPreviewButton: true },
  _renderAmountPrice: ({ renderAmountPrice, ...props }) => renderAmountPrice({ AmountPriceContainer, ...props }),
  _onToggleOptionList: (onToggleOptionList) => {
    onToggleOptionList(
      Services.configurator.state.selectedoptionclassification,
    );
  },

  renderConfigurationVariantSelection: (showConfigurationVariantSelection) => {
    if (showConfigurationVariantSelection) {
      return <ConfigurationVariantSelectionContainer />;
    }

    return null;
  },
  renderCustomScreenComponents: () => null,
  renderCustomTitleEditorContainer: () => <CustomTitleEditorContainer />,
  renderErrorContainer: () => <ErrorContainer />,
  renderFastConfigurationContainer: (
    dispatchAction,
    onOptionClassificationSelect,
    selectOption,
    selectOptionClassification,
  ) => (
    <FastConfigurationContainer
      onOptionclassificationSelect={(optionClassification, showOptionList) => onOptionClassificationSelect(
        dispatchAction,
        optionClassification,
        selectOptionClassification,
        showOptionList,
      )}
      onOptionSelect={(option) => selectOption(dispatchAction, option)}
    />
  ),
  renderHeader: () => <Header />,
  renderIncompatibilityDialog: (
    viewOptionDetails,
    resolveConflicts,
    dispatchAction,
  ) => (
    <IncompatibilityContainer
      ruleComponentProps={{
        Optionlistitem: Option,
        viewDetails: viewOptionDetails,
      }}
      resolveConflicts={() => resolveConflicts(dispatchAction)}
    />
  ),
  renderOptionDetailContainer: (
    selectOption,
    dispatchAction,
    viewOptionDetails,
  ) => (
    <OptionDetailContainer
      onSelect={(option) => selectOption(dispatchAction, option)}
      viewDetails={(option) => viewOptionDetails(dispatchAction, option)}
    />
  ),
  renderOptionsList: (
    selectOption,
    dispatchAction,
    viewOptionDetails,
    onToggle,
    onToggleOptionList,
    _optionRef,
  ) => (
    <OptionsListContainer
      onSelect={(option) => {
        selectOption(dispatchAction, option);
      }}
      viewDetails={(option) => viewOptionDetails(dispatchAction, option)}
      onToggle={() => onToggle(onToggleOptionList)}
      optionRef={_optionRef}
    />
  ),
  renderProductParts: (
    dispatchAction,
    onOptionClassificationSelect,
    selectOptionClassification,
  ) => (
    <ProductPartsListContainer
      onSelect={(optionClassification) => {
        onOptionClassificationSelect(
          dispatchAction,
          optionClassification,
          selectOptionClassification,
        );
      }}
    />
  ),
  renderInvalidConfigurationNotice: () => <InvalidConfigurationNotice />,

  onOptionClassificationSelect: (
    dispatchAction,
    optionClassification,
    selectOptionClassification,
    showOptionList = true,
  ) => selectOptionClassification(
    dispatchAction,
    optionClassification,
    true,
    showOptionList,
  ),
  resolveConflicts: (dispatchAction) => dispatchAction(configuratorActions.resolveConflicts()),
  selectOption: (
    dispatchAction,
    option,
    refreshOptionList = true,
    showOptionDetails = false,
    optionClassification = false,
  ) => dispatchAction(
    configuratorActions.selectOption(
      option,
      refreshOptionList,
      showOptionDetails,
      optionClassification,
    ),
  ),
  selectOptionClassification: (
    dispatchAction,
    optionClassification = {},
    triggerFetchOptions = false,
    showOptionList = false,
  ) => dispatchAction(
    configuratorActions.selectOptionclassification(
      optionClassification,
      triggerFetchOptions,
      showOptionList,
    ),
  ),
  onToggleOptionList: () => {},
  viewOptionDetails: (dispatchAction, option) => dispatchAction(configuratorActions.viewOptionDetails(option)),

  Layout: DefaultLayout,
};
export default CustomCreatorScreen;
